// v2: bumped to force a one-time full resync so the IDB mirror repopulates
// autorNombre (added to LocalReport). Older incremental caches lacked it,
// leaving the admin Informes "Técnico" column blank until a filtered fetch.
const LAST_SYNC_KEY = "marco.lastSync.v2";

export function getLastSync(): string | null {
  try {
    return localStorage.getItem(LAST_SYNC_KEY);
  } catch {
    return null;
  }
}

export function setLastSync(iso: string): void {
  try {
    localStorage.setItem(LAST_SYNC_KEY, iso);
  } catch {
    // best-effort; ignore quota / security errors
  }
}

/** Forget the sync anchor so the next list load does a full fetch. */
export function clearLastSync(): void {
  try {
    localStorage.removeItem(LAST_SYNC_KEY);
  } catch {
    // best-effort
  }
}
